import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { CityDto, CompanyCatalogFilters, CompanyInfo, CountryDto, PagedResponse, SectorDto } from '../shared/dto/models-dto';

@Injectable({
  providedIn: 'root'
})


export class AllCompaniesService {
  
  constructor(private http: HttpClient) {}

    getCompanies(filters: CompanyCatalogFilters): Observable<PagedResponse<CompanyInfo>> {
      let params = new HttpParams().set('page', filters.page);

      if (filters.search) params = params.set('search', filters.search);
      if (filters.countryId != null) params = params.set('countryId', filters.countryId);
      filters.cityIds?.forEach(cityId => params = params.append('cityIds', cityId));
      if (filters.sectorId != null) params = params.set('sectorId', filters.sectorId);
      if (filters.badge) params = params.set('badge', true);
      if (filters.minInclusionIndex != null) params = params.set('minInclusionIndex', filters.minInclusionIndex);
      if (filters.minLeadershipScore != null) params = params.set('minLeadershipScore', filters.minLeadershipScore);
      if (filters.minIntegrationScore != null) params = params.set('minIntegrationScore', filters.minIntegrationScore);
      if (filters.minMentorshipScore != null) params = params.set('minMentorshipScore', filters.minMentorshipScore);
      if (filters.minCulturalScore != null) params = params.set('minCulturalScore', filters.minCulturalScore);
      if (filters.minOutcomeScore != null) params = params.set('minOutcomeScore', filters.minOutcomeScore);

      return this.http.get<PagedResponse<CompanyInfo>>(
        `${environment.apiUrl}/api/trainees/full-details`,
        { params }
      );
    }
  
    getCompanyFullDetails(id: number): Observable<any> {
      return this.http.get(`${environment.apiUrl}/api/trainees/full-details/${id}`);
      }

    getSectors(): Observable<SectorDto[]> {
      return this.http.get<SectorDto[]>(`${environment.apiUrl}/api/companies/sectors`);
    }

    uploadLogo(companyId: number, file: File): Observable<string> {
      const formData = new FormData();
      formData.append('file', file);

      return this.http.post<string>(`${environment.apiUrl}/api/trainees/${companyId}/logo`, formData, {
        responseType: 'text' as 'json'
      });
    }

    getLogo(companyId: number): Observable<string> {
      return this.http.get(`${environment.apiUrl}/api/trainees/${companyId}/logo`, { responseType: 'text' });
    }

     getCountries(): Observable<CountryDto[]> {
      return this.http.get<CountryDto[]>(`${environment.apiUrl}/api/countries/existing`);
    }

    getCities(): Observable<CityDto[]> {
      return this.http.get<CityDto[]>(`${environment.apiUrl}/api/cities/existing`);
    }
}
